module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-metals-remnants.87308eb5.png";